(() => {
  if (window.__mkoCollectionCardsReady) return;
  window.__mkoCollectionCardsReady = true;

  const selectVariant = (button) => {
    const card = button.closest('[data-mko-collection-card]');
    if (!card) return;

    card.querySelectorAll('[data-mko-variant]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const colorName = button.dataset.colorName || '';
    const selectedColor = card.querySelector('[data-mko-selected-color]');
    if (selectedColor) selectedColor.textContent = colorName;

    const destinationUrl = button.dataset.url;
    if (destinationUrl) {
      card.querySelectorAll('[data-mko-card-link]').forEach((link) => {
        link.href = destinationUrl;
      });
    }

    const image = card.querySelector('.mko-collection-card__image');
    const nextImage = button.dataset.imageSrc;

    if (image && nextImage) {
      image.classList.add('is-changing');

      const nextSrcset = button.dataset.imageSrcset;
      if (nextSrcset) {
        image.srcset = nextSrcset;
      } else {
        image.removeAttribute('srcset');
      }

      image.src = nextImage;
      image.alt = button.dataset.imageAlt || image.alt;

      const reveal = () => image.classList.remove('is-changing');
      if (image.complete) {
        requestAnimationFrame(reveal);
      } else {
        image.addEventListener('load', reveal, { once: true });
        image.addEventListener('error', reveal, { once: true });
      }
    }

    const price = card.querySelector('[data-mko-price]');
    if (price && button.dataset.price) {
      price.textContent = button.dataset.price;
    }

    const compare = card.querySelector('[data-mko-compare]');
    if (compare) {
      const compareValue = button.dataset.compare || '';
      compare.textContent = compareValue;
      compare.hidden = !compareValue;
    }

    const discount = Number(button.dataset.discount || 0);
    const ribbon = card.querySelector('[data-mko-sale-ribbon]');
    if (ribbon) {
      ribbon.textContent = discount > 0 ? `-${discount}%` : '';
      ribbon.hidden = discount <= 0;
    }

    const available = button.dataset.available === 'true';
    const soldOut = card.querySelector('[data-mko-soldout]');
    if (soldOut) soldOut.hidden = available;
    card.classList.toggle('is-variant-sold-out', !available);
  };

  let reorderFrame = null;

  const moveSoldOutToEnd = () => {
    window.cancelAnimationFrame(reorderFrame);
    reorderFrame = window.requestAnimationFrame(() => {
      document.querySelectorAll('.js-product-grid').forEach((grid) => {
        const items = Array.from(grid.children).filter((item) => item.classList.contains('clm'));
        if (items.length < 2) return;

        const available = [];
        const soldOut = [];

        items.forEach((item) => {
          const card = item.querySelector('[data-mko-collection-card]');
          const unavailable = card?.dataset.mkoProductAvailable === 'false';
          (unavailable ? soldOut : available).push(item);
        });

        const desired = available.concat(soldOut);
        const alreadyOrdered = desired.every((item, index) => item === items[index]);
        if (alreadyOrdered) return;

        desired.forEach((item) => grid.appendChild(item));
      });
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mko-variant]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    selectVariant(button);
  });

  const collectionContainer = document.getElementById('mainCollectionProductContainer');
  if (collectionContainer) {
    const observer = new MutationObserver(moveSoldOutToEnd);
    observer.observe(collectionContainer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveSoldOutToEnd, { once: true });
  } else {
    moveSoldOutToEnd();
  }

  document.addEventListener('shopify:section:load', moveSoldOutToEnd);
})();
